import { JobPostingDetailDto } from '../models/job-posting.model';
import {
  ExperienceLevelEnum,
  PositionTypeEnum,
  ScopeOfPracticeEnum
} from '@umss/shared/utils';

export const JOB_POSTINGS_DETAILS_MOCK: JobPostingDetailDto[] = [
  {
    id: 'job-001',
    facility: {
      id: 'fac-001',
      name: 'West Jordan Clinic',
      fullAddress: '123 Street, Midvale, UT 84555',
      distanceMiles: 4.8
    },
    postedAt: '2025-06-19T00:00:00Z',
    scopeOfPractice: ScopeOfPracticeEnum.Lpn,
    scopeOfPracticeDisplay: 'Licensed Practical Nurse',
    positionType: PositionTypeEnum.FullTime,
    positionTypeDisplay: 'Full-Time',
    experienceLevel: ExperienceLevelEnum.MidLevel,
    experienceLevelDisplay: 'Mid Level',
    priceRange: { minHourlyRate: 48, maxHourlyRate: 72 },
    interestedAt: '2025-06-20T00:00:00Z',
    interestedCount: 12,
    description:
      'West Jordan Clinic is seeking a compassionate and skilled Licensed Practical Nurse to join our growing team. ' +
      'The ideal candidate will provide direct patient care, administer medications, and collaborate with physicians and RNs to deliver high-quality outcomes. ' +
      'Responsibilities include monitoring vital signs, documenting patient records, and educating patients and families on care plans. ' +
      'We offer a supportive environment with competitive pay, flexible scheduling, and opportunities for professional growth. ' +
      'Minimum 2 years of LPN experience required. Active Utah LPN license and CPR certification mandatory.'
  },
  {
    id: 'job-002',
    facility: {
      id: 'fac-002',
      name: 'Sacred Heart',
      fullAddress: '456 Main Ave, Salt Lake City, UT 84101',
      distanceMiles: 14
    },
    postedAt: '2025-06-15T00:00:00Z',
    scopeOfPractice: ScopeOfPracticeEnum.Rn,
    scopeOfPracticeDisplay: 'Registered Nurse',
    positionType: PositionTypeEnum.FullTime,
    positionTypeDisplay: 'Full-Time',
    experienceLevel: ExperienceLevelEnum.EntryLevel,
    experienceLevelDisplay: 'Entry Level',
    priceRange: { minHourlyRate: 41, maxHourlyRate: 58 },
    interestedCount: 7,
    description:
      'Sacred Heart is hiring entry-level Registered Nurses for our medical-surgical unit. ' +
      'New graduates are welcome — we provide a robust 12-week orientation program and dedicated clinical mentors throughout your first year. ' +
      'Duties include patient assessments, care plan development, IV therapy, and interdisciplinary communication. ' +
      'We value a patient-first culture and invest in your long-term career development. ' +
      'BSN preferred; active Utah RN license required.'
  },
  {
    id: 'job-003',
    facility: {
      id: 'fac-003',
      name: 'Mayo Clinic',
      fullAddress: '789 Clinic Blvd, Murray, UT 84123',
      distanceMiles: 22
    },
    postedAt: '2025-06-10T00:00:00Z',
    scopeOfPractice: ScopeOfPracticeEnum.Rn,
    scopeOfPracticeDisplay: 'Registered Nurse',
    positionType: PositionTypeEnum.PartTime,
    positionTypeDisplay: 'Part-Time',
    experienceLevel: ExperienceLevelEnum.Senior,
    experienceLevelDisplay: 'Senior',
    priceRange: { minHourlyRate: 53, maxHourlyRate: 77 },
    interestedCount: 5,
    description:
      'Mayo Clinic is looking for an experienced part-time RN to support our oncology unit. ' +
      'The successful candidate will have a minimum of 5 years of acute-care nursing experience and demonstrate strong critical-thinking skills. ' +
      'Responsibilities include chemotherapy administration, symptom management, patient education, and participation in quality-improvement initiatives. ' +
      'MSN or oncology certification (OCN) is a significant advantage. ' +
      'Flexible scheduling available — 2 to 3 shifts per week. Active Utah RN license required.'
  },
  {
    id: 'job-004',
    facility: {
      id: 'fac-004',
      name: 'Intermountain Medical Center',
      fullAddress: '5121 S Cottonwood St, Murray, UT 84107',
      distanceMiles: 8.3
    },
    postedAt: '2025-06-08T00:00:00Z',
    scopeOfPractice: ScopeOfPracticeEnum.Cna,
    scopeOfPracticeDisplay: 'Certified Nursing Assistant',
    positionType: PositionTypeEnum.FullTime,
    positionTypeDisplay: 'Full-Time',
    experienceLevel: ExperienceLevelEnum.MidLevel,
    experienceLevelDisplay: 'Mid Level',
    priceRange: { minHourlyRate: 46, maxHourlyRate: 63 },
    interestedCount: 19,
    description:
      'Intermountain Medical Center is seeking a reliable and empathetic CNA for our long-term care wing. ' +
      'You will assist patients with daily living activities, mobility, and personal hygiene while maintaining a safe and comfortable environment. ' +
      'Strong communication skills and the ability to work collaboratively with a multidisciplinary team are essential. ' +
      'We offer full benefits, tuition reimbursement, and a clear pathway for advancement to LPN or RN roles. ' +
      'Active Utah CNA certification and minimum 2 years of experience required.'
  },
  {
    id: 'job-005',
    facility: {
      id: 'fac-005',
      name: 'University of Utah Hospital',
      fullAddress: '50 N Medical Dr, Salt Lake City, UT 84132',
      distanceMiles: 11.5
    },
    postedAt: '2025-06-01T00:00:00Z',
    scopeOfPractice: ScopeOfPracticeEnum.Lpn,
    scopeOfPracticeDisplay: 'Licensed Practical Nurse',
    positionType: PositionTypeEnum.Contract,
    positionTypeDisplay: 'Contract',
    experienceLevel: ExperienceLevelEnum.Senior,
    experienceLevelDisplay: 'Senior',
    priceRange: { minHourlyRate: 58, maxHourlyRate: 84 },
    interestedCount: 3,
    description:
      'University of Utah Hospital is offering a 6-month contract LPN position in our outpatient specialty clinic. ' +
      'Senior-level candidates will triage patients, perform venipuncture, administer immunisations, and manage electronic health records via Epic. ' +
      'You will work alongside specialist physicians and advanced practice providers in a fast-paced academic medical environment. ' +
      'Contract may be extended or converted to permanent based on performance and departmental need. ' +
      'Minimum 5 years of LPN experience; experience in a specialty-clinic setting strongly preferred. Active Utah LPN license required.'
  }
];
